import React, { FC } from 'react';
import Container from '../../../../Common/Container/Container';
import * as classes from './PreFooter.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import PagesList from './PagesList/PagesList';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../interfaces/RootState';

interface Props {
  currentPage: string;
}

const PreFooter: FC<Props> = ({ currentPage }) => {
  const { t } = useTranslation();
  const { preFooterPages } = useSelector((state: RootState) => state.nav);
  return (
    <section className={classes.wrapper}>
      <Container>
        <div className={classes.title} data-aos='fade-in' data-aos-delay='300'>
          {t('preFooter.title')}
        </div>
        <PagesList items={preFooterPages.items} currentPage={currentPage} />
      </Container>
    </section>
  );
};

export default PreFooter;
